export const BEASTMEN_SIZE_FOR_SUPPLY_ON_BARRACKS = 3;
export const BEASTMEN_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP = 5;
export const BEASTMEN_WIN_POINTS_BONUS_ON_KILL = 1;